"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.MoreRightIconWrapper = exports.ListItem = exports.PopoverBody = exports.Popover = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
const styled_components_1 = __importStar(require("styled-components"));
exports.Popover = (0, styled_components_1.default)(material_1.Popover) `
  margin-left: 15px;
  margin-top: 3px;
`;
exports.PopoverBody = styled_components_1.default.div `
  padding: 8px;
`;
exports.ListItem = (0, styled_components_1.default)(({ ...props }) => (0, jsx_runtime_1.jsx)(material_1.ListItem, { ...props }))(({ theme: { palette, shape }, $active }) => (0, styled_components_1.css) `
    margin-bottom: 5px;
    padding: 0px;
    border-radius: ${shape.borderRadius}px;
    color: ${$active ? palette.common.white : palette.info.main};
    cursor: pointer;
    background-color: ${$active ? palette.action.selected : undefined};

    &:hover {
      background-color: ${palette.action.selected};
    }
  `);
exports.MoreRightIconWrapper = styled_components_1.default.div `
  display: flex;
  margin-right: 15px;
`;
